/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/cp35th/js/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports) {

	jQuery(function($){
	  var hot_ids = {
	    "1244962": {
	      secret: false,
	      title: '<span class="phrase">和風総本家 スペシャル</span><span class="phrase">「世界で見つけた Made in Japan」</span>'
	    },
	    "1244976": {
	      secret: false,
	      title: '<span class="phrase">開局35周年 それ、テレビ大阪やろ。</span><span class="phrase">アレ、なんでやねん！！大阪人の生態学～VSスペシャル～</span>'
	    },
	    "1245100": {
	      secret: false,
	      title: '<span class="phrase">開局35周年</span> <span class="phrase">それ、テレビ大阪やろ。春祭り（ひる）</span>'
	    },
	    "1245101": {
	      secret: false,
	      title: '<span class="phrase">開局35周年 それ、テレビ大阪やろ。</span><span class="phrase">おとな旅あるき旅 2時間30分スペシャル 大阪環状線から行く名物路線！途中下車の旅</span>'
	    },
	    "1245102": {
	      secret: false,
	      title: '<span class="phrase">開局35周年</span> <span class="phrase">それ、テレビ大阪やろ。春祭り（よる）</span>'
	    },
	    "1245103": {
	      secret: false,
	      title: '<span class="phrase">開局35周年 それ、テレビ大阪やろ。</span><span class="phrase">2017タイガースキャンプSP ～江夏豊 石田純一 金本阪神の本気を見た！～</span>'
	    },
	    "1245104": {
	      secret: false,
	      title: '<span class="phrase">開局35周年 それ、テレビ大阪やろ。</span><span class="phrase">やすとものどこいこ！？2時間スペシャル</span>'
	    }
	  };
	  $.when(
	    tvo.timetables.pushed.create(),
	    $.ajax({
	      url: "http://cdn.tv-osaka.co.jp/ip4/program/onair/pushed.jsonp",
	      type: "GET",
	      jsonpCallback: "_pushedStaticJsonpCallback",
	      scriptCharset: "utf-8",
	      dataType: "jsonp"
	    }).then(function(json){
	      return _.map(json.select, tvo.widget.onair.prototype.createProgram);
	    })
	  ).done(function(pushed_programs, noepg_pushed_programs){
	    pushed_programs = pushed_programs.concat(noepg_pushed_programs);
	    pushed_programs = _.chain(pushed_programs)
	      .filter(function(onair){
	        if( !onair || (onair.getEndTime() && onair.getEndTime() < (new Date()).getTime()/1000) || !_(Object.keys(hot_ids)).contains(onair.getMetaValues("onair_id")[0]) ){
	          return false;
	        }
	        return true;
	      })
	      .uniq(function(onair){
	        return onair.getMetaValues("onair_id")[0];
	      })
	      .sortBy(function(onair){
	        return onair.getStartDate().getTime();
	      })
	      .value();

	    var render = function($tpl, onair){
	      if(_.isArray(onair)){
	        _(onair).each(function(o){
	          render($tpl, o);
	        });
	        return;
	      }
	      var template = _.template($tpl.html());
	      var onair_id = onair.getMetaValues("onair_id")[0];
	      var html = template($.extend({
	        id: onair_id,
	        today:
	          tvo.timetables.createDateNum(onair.getStartDate(), {normalize:true})
	            === tvo.timetables.createDateNum(new Date(), {normalize:true}),
	        title: onair.getTitle(),
	        url: onair.getURL(),
	        day: onair.getDateStr(undefined, false),
	        time: onair.getTimeStr() + "～",
	        image: onair.getImage("r1609"),
	        video: onair.getVideo("brightcove")||onair.getVideo("equipmedia")
	      }, hot_ids[onair_id]));
	      $($.parseHTML(html)).insertBefore($tpl).find(".tvo-video").trigger("build.tvo-video");
	    };

	    var $programs = $("article.programs");

	    if(!pushed_programs || pushed_programs.length === 0){
	      $programs.hide();
	      return false;
	    }

	    render($("script.next.template"), pushed_programs.shift());
	    render($("script.all.template"), pushed_programs);

	    $programs
	      .find(".tvo-video").trigger("build.tvo-video").end()
	      .find("ul.all").each(function(){
	        $(this).find("li").length === 0 && $(this).remove();
	      });
	  });
	});

/***/ }
/******/ ]);